import { render, staticRenderFns } from "./CompetitionArchiveManagement.vue?vue&type=template&id=000dc21f&scoped=true"
import script from "./CompetitionArchiveManagement.vue?vue&type=script&lang=js"
export * from "./CompetitionArchiveManagement.vue?vue&type=script&lang=js"
import style0 from "./CompetitionArchiveManagement.vue?vue&type=style&index=0&id=000dc21f&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "000dc21f",
  null
  
)

export default component.exports